import { makeAutoObservable } from "mobx";
import { vsprintf } from 'sprintf-js';
import { ITranslationRecord } from "../../services/api/translations-service";
import ErrorReportingService from "../../services/error-reporting.service";
import {rootContainer, TYPE} from "../../services/container/root";


interface IDashboardTranslationsMap {
    [scope: string]: {
        [key: string]: ITranslationRecord
    }
}

export default class DashboardTranslationLocaleStore {
    private _translationsMap: IDashboardTranslationsMap = {};

    private get errorReportingService(): ErrorReportingService {
        return rootContainer.get<ErrorReportingService>(TYPE.ErrorReportingService);
    }

    constructor(translations: ITranslationRecord[]) {
        makeAutoObservable(this);
        this.createTranslationsMap(translations);
    }

    private createTranslationsMap(translations: ITranslationRecord[]) {
        translations.forEach(trans => {
            this._translationsMap[trans.scope] = this._translationsMap[trans.scope] ?? {};
            this._translationsMap[trans.scope][trans.key] = trans;
        });
    }

    /** when no scope.key exists in translations - return scope.key as is */
    public getTranslation(key:string, scope: string, args: string[] = []): string {
        if (this._translationsMap[scope] && this._translationsMap[scope][key]) {
            if (args && args.length > 0) {
                return vsprintf(this._translationsMap[scope][key].translation, args);
            }
            return this._translationsMap[scope][key].translation;
        }

        const scopeKey = `${scope}.${key}`;
        this.errorReportingService.captureException(new Error(`Translation not found: ${scopeKey}`));

        return scopeKey;
    }
}

